import { usePermissions as usePermissionsContext } from '../shared/contexts/permissions.context';

// Re-export for easier imports
export { usePermissions } from '../shared/contexts/permissions.context';

// Additional convenience hooks
export const useHasPermission = (permission: string) => {
  const { hasPermission } = usePermissionsContext();
  return hasPermission(permission as any);
};

export const useHasAnyPermission = (permissions: string[]) => {
  const { hasAnyPermission } = usePermissionsContext();
  return hasAnyPermission(permissions as any);
};

export const useHasAllPermissions = (permissions: string[]) => {
  const { hasAllPermissions } = usePermissionsContext();
  return hasAllPermissions(permissions as any);
};

// Specific permission hooks for commonly used permissions
export const useCanAccessDashboard = () => useHasPermission('canAccessDashboard');
export const useCanAccessBuildings = () => useHasPermission('canAccessBuildings');
export const useCanAccessUnits = () => useHasPermission('canAccessUnits');
export const useCanAccessContacts = () => useHasPermission('canAccessContacts');
export const useCanAccessAcquisitions = () => useHasPermission('canAccessAcquisitions');
export const useCanAccessRental = () => useHasPermission('canAccessRental');
export const useCanAccessSettings = () => useHasPermission('canAccessSettings');
export const useCanAccessDocuments = () => useHasPermission('canAccessDocuments');
export const useCanAccessTasks = () => useHasPermission('canAccessTasks');
export const useCanAccessNotes = () => useHasPermission('canAccessNotes');
export const useCanAccessHelpdesk = () => useHasPermission('canAccessHelpdesk');
export const useCanAccessMaintenance = () => useHasPermission('canAccessMaintenance');
export const useCanAccessRenovation = () => useHasPermission('canAccessRenovation');
export const useCanAccessInsurance = () => useHasPermission('canAccessInsurance');
export const useCanAccessPictures = () => useHasPermission('canAccessPictures');
export const useCanAccessClusters = () => useHasPermission('canAccessClusters');
export const useCanAccessConversations = () => useHasPermission('canAccessConversations');
export const useCanAccessDueDiligence = () => useHasPermission('canAccessDueDiligence');
export const useCanAccessBuildingAttributes = () => useHasPermission('canAccessBuildingAttributes');
export const useCanAccessGeneral = () => useHasPermission('canAccessGeneral');
export const useCanAccessCorporate = () => useHasPermission('canAccessCorporate');
export const useCanEditCorporate = () => useHasPermission('canEditCorporate');
export const useCanEditUnitIds = () => useHasPermission('canEditUnitIds');
